import formatNumber from './format_number';

export const getFormattedNumber = (setup, value) =>
    formatNumber(
        setup.valueFormatter(value),
        {
            thousandsSeparator: setup.thousandsSeparator,
            decimalSeparator: setup.decimalSeparator,
            decimalDigits: setup.decimalDigits
        });
